export const controlSurface = [
  'w-full rounded-md border border-input bg-background text-sm text-foreground',
  'shadow-[0_1px_2px_0_rgb(15_23_42/0.05)] transition-[border-color,box-shadow,background-color] duration-150',
  'placeholder:text-muted-foreground/70',
  'hover:border-muted-foreground/40',
  'focus-visible:border-ring focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/25',
  'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive/20',
  'disabled:cursor-not-allowed disabled:bg-muted/60 disabled:text-muted-foreground disabled:hover:border-input',
].join(' ');

export const controlShell = [
  'w-full rounded-md border border-input bg-background text-sm text-foreground',
  'shadow-[0_1px_2px_0_rgb(15_23_42/0.05)] transition-[border-color,box-shadow,background-color] duration-150',
  'hover:border-muted-foreground/40',
  'focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/25',
  'has-[input[aria-invalid=true]]:border-destructive has-[input[aria-invalid=true]]:focus-within:ring-destructive/20',
  'data-[disabled]:cursor-not-allowed data-[disabled]:bg-muted/60 data-[disabled]:text-muted-foreground data-[disabled]:hover:border-input',
].join(' ');

export const shellInput =
  'h-full min-w-0 flex-1 bg-transparent ps-3 text-sm outline-none placeholder:text-muted-foreground/70 disabled:cursor-not-allowed';

export const shellButton =
  'grid h-full w-9 shrink-0 place-items-center rounded-e-md text-muted-foreground transition-colors hover:text-foreground focus-visible:text-primary focus-visible:outline-none disabled:pointer-events-none';
